import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { Option as SelectOption, Select } from 'carbon-react/lib/components/select';

import { BusinessInsightSchedule } from '@futrli-sdk/predict';

import { Recurrence } from './types';

interface SendingSelectProps {
  recurrence: Recurrence;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  activeSchedule?: BusinessInsightSchedule;
  hasSchedules: boolean;
}

export const SendingSelect = ({ recurrence, onChange, activeSchedule, hasSchedules }: SendingSelectProps) => {
  const intl = useIntl();

  const options = useMemo(() => {
    const sendingOptions = [
      {
        value: Recurrence.DAILY,
        text: intl.formatMessage({ id: 'common.sending_email_daily', defaultMessage: 'Daily' })
      },
      {
        value: Recurrence.WEEKLY,
        text: intl.formatMessage({ id: 'common.sending_email_weekly', defaultMessage: 'Weekly' })
      },
      {
        value: Recurrence.MONTHLY,
        text: intl.formatMessage({ id: 'common.sending_email_monthly', defaultMessage: 'Monthly' })
      }
    ];
    if (activeSchedule) {
      sendingOptions.push({
        value: Recurrence.OPT_OUT_THIS,
        text: intl.formatMessage({
          id: 'predict.opt_out_this_insights_email',
          defaultMessage: 'Opt out of this insights email'
        })
      });
    }

    if (hasSchedules) {
      sendingOptions.push({
        value: Recurrence.OPT_OUT_ALL,
        text: intl.formatMessage({
          id: 'predict.opt_out_all_insights_emails',
          defaultMessage: 'Opt out of insights emails - all'
        })
      });
    }

    return sendingOptions;
  }, [intl, activeSchedule, hasSchedules]);

  return (
    <Select
      onChange={onChange}
      id="sending"
      value={recurrence}
      label={intl.formatMessage({ id: 'common.sending', defaultMessage: 'Sending' })}
      name="sending"
      size="medium"
      required
      mb="16px"
    >
      {options.map(option => (
        <SelectOption key={option.value} value={option.value} text={option.text} />
      ))}
    </Select>
  );
};
